module.exports = __webpack_public_path__ + "458e20c42c1b3d371708c421b919cffc.jpg";